module.exports = __webpack_public_path__ + "static/002-dd0ef06277f30ab5d606b700a542f10a.jpg";